( function( $, window, document, undefined ) {

	/**
	 * Check to see if the local storage should have expires.
	 */
	$( window ).on( 'load', function(){

		// Drepreciate `alert` local storeage key.
		if( localStorage.getItem("alert") || localStorage.getItem("timestamp") ){
			localStorage.removeItem("alert");
			localStorage.removeItem("timestamp");
		}

		var alert_timestamp = localStorage.getItem("alert_timestamp");
		var now = new Date().getTime().toString();

		var dif = (now - alert_timestamp) / 1000;

		// Value in seconds (86400 = 24hrs in seconds).
		if ( dif >= 86400 ) {
			localStorage.removeItem("alert_status");
			localStorage.removeItem("alert_timestamp");
		}

		var alert_status = localStorage.getItem("alert_status")

		if( alert_status !== 'closed' ){
			$( '.c-alert-bar' ).removeClass( 'c-alert-closed' );
		}

	});

	$( '.js-close-alert' ).on( 'touchstart click', function(){

		$( '.c-alert-bar' ).addClass( 'c-alert-closed' );

		var alert_status = 'closed';

		localStorage.setItem("alert_status", alert_status);

		/* Add a timestamp as local storage doesn't automatically expire. */
		var alert_timestamp = new Date().getTime();
		localStorage.setItem("alert_timestamp", alert_timestamp );

	});


})( jQuery, window, document );
